import { render, staticRenderFns } from "./AccountDividends.html?vue&type=template&id=e8113766&"
import script from "./AccountDividends.ts?vue&type=script&lang=ts&"
export * from "./AccountDividends.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/account/_dividends.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports